import { useEffect, useState } from "react";

export const useCurrentUser = () => {
  const [userName, setUserName] = useState<string>("");

  useEffect(() => {
    setUserName(JSON.parse(localStorage.getItem("user")!)?.username);
  }, []);
  
  return { userName };
};
